import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import TourPage from "@/pages/TourPage";
import LegalPage from "@/pages/LegalPage";
import CookieNotice from "@/components/landing/CookieNotice";
import { LEGAL } from "@/lib/legal";

function RouteEffects() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        requestAnimationFrame(() => el.scrollIntoView({ behavior: "smooth" }));
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: pathname, page_location: window.location.href });
    }
  }, [pathname, hash]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <RouteEffects />
      <div className="min-h-screen bg-[#0D1117] font-sans text-stone-100 antialiased selection:bg-amber-400 selection:text-[#0D1117]">
        <div className="grain-overlay" aria-hidden="true" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacidade" element={<LegalPage doc={LEGAL.privacidade} />} />
          <Route path="/termos" element={<LegalPage doc={LEGAL.termos} />} />
          <Route path="/:slug" element={<TourPage />} />
        </Routes>
        <CookieNotice />
      </div>
    </BrowserRouter>
  );
}
